const RETRY_LIMITS = {
  retry_count: { min: 0, max: 10 },
  retry_interval_hours: { min: 1, max: 24 },
};

function wholeNumberInRange(value, min, max) {
  if (typeof value === 'number') {
    return Number.isInteger(value) && value >= min && value <= max ? value : null;
  }
  if (typeof value !== 'string') return null;
  const text = value.trim();
  if (!/^\d+$/.test(text)) return null;
  const number = Number(text);
  return number >= min && number <= max ? number : null;
}

function normalizeRetrySettings(report) {
  const retry_count = wholeNumberInRange(
    report?.retry_count,
    RETRY_LIMITS.retry_count.min,
    RETRY_LIMITS.retry_count.max,
  );
  const retry_interval_hours = wholeNumberInRange(
    report?.retry_interval_hours,
    RETRY_LIMITS.retry_interval_hours.min,
    RETRY_LIMITS.retry_interval_hours.max,
  );
  return {
    retry_count,
    retry_interval_hours,
    errors: {
      retry_count: retry_count == null,
      retry_interval_hours: retry_interval_hours == null,
    },
  };
}

module.exports = {
  normalizeRetrySettings,
};
